"use client";

import Image from "@/components/CwfImage";

export const CURRENCY_ICON_PATH = {
  coin: "/ui/icons/coin.webp",
  gem: "/ui/icons/gem.webp",
  energy: "/ui/icons/energy.webp",
  xpStar: "/ui/icons/xp-star.webp",
} as const;

export type CurrencyIconKind = keyof typeof CURRENCY_ICON_PATH;

export function CurrencyIcon({
  kind,
  size = 20,
  className = "",
  priority,
}: {
  kind: CurrencyIconKind;
  /** Logical pixel width & height */
  size?: number;
  className?: string;
  priority?: boolean;
}) {
  return (
    <Image
      src={CURRENCY_ICON_PATH[kind]}
      alt=""
      width={size}
      height={size}
      className={`pointer-events-none select-none object-contain ${className}`}
      draggable={false}
      priority={priority}
    />
  );
}
